export default __webpack_public_path__ + "static/media/pantry1-afterE-2048w.e6dd71f3.png";